import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/apps/',
    component: ComponentCreator('/apps/', 'f4c'),
    exact: true
  },
  {
    path: '/blog/',
    component: ComponentCreator('/blog/', '0ca'),
    exact: true
  },
  {
    path: '/blog/archive/',
    component: ComponentCreator('/blog/archive/', '1d9'),
    exact: true
  },
  {
    path: '/blog/authors/',
    component: ComponentCreator('/blog/authors/', '347'),
    exact: true
  },
  {
    path: '/blog/bitcoin-block-streaming-grpc-vs-json-rpc/',
    component: ComponentCreator('/blog/bitcoin-block-streaming-grpc-vs-json-rpc/', 'f01'),
    exact: true
  },
  {
    path: '/blog/bitcoin-fee-estimation-rbf-cpfp-batch-guide/',
    component: ComponentCreator('/blog/bitcoin-fee-estimation-rbf-cpfp-batch-guide/', '4ad'),
    exact: true
  },
  {
    path: '/blog/bitcoin-fee-estimation-wallet-integration/',
    component: ComponentCreator('/blog/bitcoin-fee-estimation-wallet-integration/', '036'),
    exact: true
  },
  {
    path: '/blog/bitcoin-mempool-fee-spikes-developer-guide/',
    component: ComponentCreator('/blog/bitcoin-mempool-fee-spikes-developer-guide/', '67b'),
    exact: true
  },
  {
    path: '/blog/bitcoin-rpc-vs-indexed-api-developers/',
    component: ComponentCreator('/blog/bitcoin-rpc-vs-indexed-api-developers/', 'f6a'),
    exact: true
  },
  {
    path: '/blog/custom-blockchain-indexer-what-it-takes/',
    component: ComponentCreator('/blog/custom-blockchain-indexer-what-it-takes/', '75a'),
    exact: true
  },
  {
    path: '/blog/evm-eip1559-gas-fee-estimation-guide/',
    component: ComponentCreator('/blog/evm-eip1559-gas-fee-estimation-guide/', 'b6d'),
    exact: true
  },
  {
    path: '/blog/how-bitcoin-fees-work/',
    component: ComponentCreator('/blog/how-bitcoin-fees-work/', 'b24'),
    exact: true
  },
  {
    path: '/blog/how-to-backfill-bitcoin-indexer-fast/',
    component: ComponentCreator('/blog/how-to-backfill-bitcoin-indexer-fast/', '176'),
    exact: true
  },
  {
    path: '/blog/managed-blockchain-indexer-vs-self-hosted/',
    component: ComponentCreator('/blog/managed-blockchain-indexer-vs-self-hosted/', 'ee8'),
    exact: true
  },
  {
    path: '/blog/pay-as-you-go-vs-subscription-blockchain-api/',
    component: ComponentCreator('/blog/pay-as-you-go-vs-subscription-blockchain-api/', '2da'),
    exact: true
  },
  {
    path: '/blog/tags/',
    component: ComponentCreator('/blog/tags/', 'e17'),
    exact: true
  },
  {
    path: '/blog/tags/api/',
    component: ComponentCreator('/blog/tags/api/', '3d9'),
    exact: true
  },
  {
    path: '/blog/tags/backfill/',
    component: ComponentCreator('/blog/tags/backfill/', 'b66'),
    exact: true
  },
  {
    path: '/blog/tags/billing/',
    component: ComponentCreator('/blog/tags/billing/', '7f5'),
    exact: true
  },
  {
    path: '/blog/tags/bitcoin/',
    component: ComponentCreator('/blog/tags/bitcoin/', '21a'),
    exact: true
  },
  {
    path: '/blog/tags/blockchain/',
    component: ComponentCreator('/blog/tags/blockchain/', 'dbf'),
    exact: true
  },
  {
    path: '/blog/tags/cost/',
    component: ComponentCreator('/blog/tags/cost/', '629'),
    exact: true
  },
  {
    path: '/blog/tags/cpfp/',
    component: ComponentCreator('/blog/tags/cpfp/', 'e76'),
    exact: true
  },
  {
    path: '/blog/tags/data/',
    component: ComponentCreator('/blog/tags/data/', '5a7'),
    exact: true
  },
  {
    path: '/blog/tags/development/',
    component: ComponentCreator('/blog/tags/development/', '6c3'),
    exact: true
  },
  {
    path: '/blog/tags/eip-1559/',
    component: ComponentCreator('/blog/tags/eip-1559/', '232'),
    exact: true
  },
  {
    path: '/blog/tags/ethereum/',
    component: ComponentCreator('/blog/tags/ethereum/', 'f26'),
    exact: true
  },
  {
    path: '/blog/tags/evm/',
    component: ComponentCreator('/blog/tags/evm/', 'b8c'),
    exact: true
  },
  {
    path: '/blog/tags/fees/',
    component: ComponentCreator('/blog/tags/fees/', '40d'),
    exact: true
  },
  {
    path: '/blog/tags/gas/',
    component: ComponentCreator('/blog/tags/gas/', '59d'),
    exact: true
  },
  {
    path: '/blog/tags/grpc/',
    component: ComponentCreator('/blog/tags/grpc/', '9fd'),
    exact: true
  },
  {
    path: '/blog/tags/indexer/',
    component: ComponentCreator('/blog/tags/indexer/', 'f43'),
    exact: true
  },
  {
    path: '/blog/tags/infrastructure/',
    component: ComponentCreator('/blog/tags/infrastructure/', '3eb'),
    exact: true
  },
  {
    path: '/blog/tags/integration/',
    component: ComponentCreator('/blog/tags/integration/', 'f03'),
    exact: true
  },
  {
    path: '/blog/tags/mempool/',
    component: ComponentCreator('/blog/tags/mempool/', '477'),
    exact: true
  },
  {
    path: '/blog/tags/performance/',
    component: ComponentCreator('/blog/tags/performance/', '287'),
    exact: true
  },
  {
    path: '/blog/tags/polygon/',
    component: ComponentCreator('/blog/tags/polygon/', '8a9'),
    exact: true
  },
  {
    path: '/blog/tags/pricing/',
    component: ComponentCreator('/blog/tags/pricing/', '521'),
    exact: true
  },
  {
    path: '/blog/tags/rbf/',
    component: ComponentCreator('/blog/tags/rbf/', '2fd'),
    exact: true
  },
  {
    path: '/blog/tags/streaming/',
    component: ComponentCreator('/blog/tags/streaming/', '946'),
    exact: true
  },
  {
    path: '/blog/tags/wallet/',
    component: ComponentCreator('/blog/tags/wallet/', '8b6'),
    exact: true
  },
  {
    path: '/policy/',
    component: ComponentCreator('/policy/', 'f20'),
    exact: true
  },
  {
    path: '/pricing/',
    component: ComponentCreator('/pricing/', '104'),
    exact: true
  },
  {
    path: '/sandbox/',
    component: ComponentCreator('/sandbox/', '695'),
    exact: true
  },
  {
    path: '/security/',
    component: ComponentCreator('/security/', '9a6'),
    exact: true
  },
  {
    path: '/terms/',
    component: ComponentCreator('/terms/', 'f36'),
    exact: true
  },
  {
    path: '/docs/',
    component: ComponentCreator('/docs/', '4b0'),
    routes: [
      {
        path: '/docs/',
        component: ComponentCreator('/docs/', 'b67'),
        routes: [
          {
            path: '/docs/',
            component: ComponentCreator('/docs/', 'fab'),
            routes: [
              {
                path: '/docs/',
                component: ComponentCreator('/docs/', 'be8'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/apps/',
                component: ComponentCreator('/docs/apps/', '31f'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/apps/bitcoin-fees-advisor/',
                component: ComponentCreator('/docs/apps/bitcoin-fees-advisor/', '034'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/apps/bitcoin-fees-advisor/api-reference/',
                component: ComponentCreator('/docs/apps/bitcoin-fees-advisor/api-reference/', 'bc0'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/apps/bitcoin-fees-advisor/examples/',
                component: ComponentCreator('/docs/apps/bitcoin-fees-advisor/examples/', '069'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/apps/custom-indexers/',
                component: ComponentCreator('/docs/apps/custom-indexers/', '0c0'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/apps/evm-fees-advisor/',
                component: ComponentCreator('/docs/apps/evm-fees-advisor/', '2aa'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/apps/evm-fees-advisor/api-reference/',
                component: ComponentCreator('/docs/apps/evm-fees-advisor/api-reference/', 'c78'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/apps/evm-fees-advisor/examples/',
                component: ComponentCreator('/docs/apps/evm-fees-advisor/examples/', '3bb'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/apps/indexed-data-apps/',
                component: ComponentCreator('/docs/apps/indexed-data-apps/', '47b'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/apps/stream-app/',
                component: ComponentCreator('/docs/apps/stream-app/', 'cca'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/apps/stream-app/examples/',
                component: ComponentCreator('/docs/apps/stream-app/examples/', '7aa'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/apps/stream-app/formats/',
                component: ComponentCreator('/docs/apps/stream-app/formats/', 'c91'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/apps/stream-app/grpc-reference/',
                component: ComponentCreator('/docs/apps/stream-app/grpc-reference/', '33b'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/getting-started/',
                component: ComponentCreator('/docs/getting-started/', '944'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/getting-started/authentication/',
                component: ComponentCreator('/docs/getting-started/authentication/', '895'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/getting-started/billing/',
                component: ComponentCreator('/docs/getting-started/billing/', '0b0'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/reference/error-codes/',
                component: ComponentCreator('/docs/reference/error-codes/', 'cf5'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/reference/rate-limits/',
                component: ComponentCreator('/docs/reference/rate-limits/', '38d'),
                exact: true,
                sidebar: "docs"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/',
    component: ComponentCreator('/', 'e5f'),
    exact: true
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
